var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("validated-input", {
              attrs: { label: "Display Name", validate: { required: true } },
              model: {
                value: _vm.vendor.DisplayName,
                callback: function ($$v) {
                  _vm.$set(_vm.vendor, "DisplayName", $$v)
                },
                expression: "vendor.DisplayName",
              },
            }),
            _c("validated-input", {
              attrs: { label: "Account Number", validate: { required: true } },
              model: {
                value: _vm.vendor.AcctNum,
                callback: function ($$v) {
                  _vm.$set(_vm.vendor, "AcctNum", $$v)
                },
                expression: "vendor.AcctNum",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: {
                type: "submit",
                disabled: _vm.errors.any() || _vm.processing,
              },
            },
            [
              _vm.processing
                ? _c("i", { staticClass: "far fa-spinner-third fa-spin" })
                : _vm._e(),
              _vm._v(" Save\n      "),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }